module.exports = __webpack_public_path__ + "img/badger-honey.b2bdcd75.svg";